import { SvgIcon, SvgIconProps } from '@mui/material'

const SensorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 19 19" {...props}>
      <rect
        x=".989"
        y=".793"
        width="16.972"
        height="16.972"
        rx="8.486"
        fill="#29AAE1"
      />
      <rect
        x=".989"
        y=".793"
        width="16.972"
        height="16.972"
        rx="8.486"
        stroke="#282828"
        strokeWidth="1.5"
      />
      <path
        d="M5.85 11.78V7.906c0-.238.036-.437.11-.598a1.006 1.006 0 0 1 .686-.563 1.57 1.57 0 0 1 .426-.061 33.728 33.728 0 0 1 1.4.034c.289.014.564.036.824.069v.995H7.408c-.128 0-.222.034-.281.103a.356.356 0 0 0-.09.24v.715l1.923.061v.941l-1.923.062v1.874H5.85Zm5.65 0c-.289 0-.527-.044-.714-.131a.852.852 0 0 1-.42-.412c-.09-.188-.136-.43-.136-.728V6.685h1.187v3.625c0 .096.014.174.042.233.032.06.077.103.137.13a.553.553 0 0 0 .22.042h1.545v1.064H11.5Z"
        fill="#fff"
      />
    </SvgIcon>
  )
}

export default SensorIcon
